var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 35 35", fill: "none" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.294 2.64L3.734 18.2 16.8 31.268l15.56-15.56V2.64H19.294zM18.2 0L0 18.2 16.8 35 35 16.8V0H18.2z", fill: "#354147" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26.264 11.98a2.916 2.916 0 1 1-4.125-4.124 2.916 2.916 0 0 1 4.124 4.123z", fill: "#354147" })
  );
});